module.exports = __webpack_public_path__ + "img/ticket.e18d7d84.png";